import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { crmConstants } from '..';

export const useLeadForceAttachRequiredFields = (props: { houseId?: number | null }) => {
  const isPermission = useAppSelector(state => state?.userReducer?.isPermissions);

  return useQuery({
    queryKey: [crmConstants.queryKeys.LEAD_FORCE_ATTACH_REQUIRED_FIELDS],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: '/v1/lead/force-attach/required-fields',
          query: { houseId: props?.houseId }
        })
      );

      return res?.data?.data;
    },
    enabled: !!props?.houseId && isPermission?.PERMISSION_PAGE_CRM
  });
};
